import { render } from "./BlockEditor.vue?vue&type=template&id=e9893772"
import script from "./BlockEditor.vue?vue&type=script&lang=js"
export * from "./BlockEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__